var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDraftDelete = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.75L2.98423 10.9819C3.07777 12.5722 3.12455 13.3673 3.46396 13.9707C3.76274 14.5019 4.21624 14.9295 4.76407 15.1966C5.38639 15.5 6.18291 15.5 7.77595 15.5H9.22406C10.8171 15.5 11.6136 15.5 12.2359 15.1966C12.7838 14.9295 13.2373 14.5019 13.536 13.9707C13.8755 13.3673 13.9222 12.5722 14.0158 10.9819L14.5 2.75M2.5 2.75H1M2.5 2.75H14.5M14.5 2.75H16M7 6.5V11.75M10 6.5V9.5M11.5 2.75L11.1603 1.73079C11.0127 1.28821 10.939 1.06691 10.8022 0.903302C10.6813 0.758826 10.5262 0.646994 10.3509 0.578061C10.1524 0.5 9.91916 0.5 9.45263 0.5H7.54737C7.08084 0.5 6.84758 0.5 6.6491 0.578061C6.47383 0.646994 6.31867 0.758826 6.19785 0.903302C6.06103 1.06691 5.98727 1.2882 5.83974 1.73079L5.5 2.75",
    stroke: "#FF0000",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDraftDelete);
export default ForwardRef;